module.exports = __webpack_public_path__ + "static/media/logo-fcamara.4d9b4a43.svg";